import { UserRole } from '../../../shared/enums';

const PermissionsOfQuillChaptersEditor = {
  SeeEditModeButton: [UserRole.ADMIN, UserRole.EDITOR, UserRole.WRITER],
  SeeNewChangesLink: [UserRole.ADMIN, UserRole.WRITER, UserRole.EDITOR],
  SeeSendCommentsButton: [UserRole.CUSTOMER],
  SeeSubmitToEditorButton: [UserRole.WRITER],
  SeeApproveButton: [UserRole.ADMIN, UserRole.EDITOR, UserRole.CUSTOMER],
  SeeSendRepliesButton: [UserRole.WRITER],
  SeeWordCount: [
    UserRole.EDITOR,
    UserRole.ADMIN,
    UserRole.WRITER,
    UserRole.DEVELOPMENTAL_EDITOR,
    UserRole.CUSTOMER,
    UserRole.CONTENT_TEAM,
    UserRole.PRO_PROOFREADER,
  ],
  SeeVersions: [
    UserRole.EDITOR,
    UserRole.ADMIN,
    UserRole.WRITER,
    UserRole.DEVELOPMENTAL_EDITOR,
    UserRole.CONTENT_TEAM,
    UserRole.PRO_PROOFREADER,
  ],
};

export default PermissionsOfQuillChaptersEditor;
